import BaseCommunication from "../../Communication/BaseCommunication";
import store from "../../Redux/store";
//import LOGIN_ACTION from './Constants';
import {
	API_URL,
	API_BASE_URL,
	HttpMethod,
	OperationStatus,
} from "../../Communication/Constants";
import { VERIFY_OTP_ACTION } from "./Constants";

export default class OtpVerificationAction extends BaseCommunication {
	verifyOTP(requestData, callback) {
		let requestFormBody = [];
		for (let property in requestData) {
			let encodedKey = encodeURIComponent(property);
			let encodedValue = encodeURIComponent(requestData[property]);
			requestFormBody.push(encodedKey + "=" + encodedValue);
		}
		requestFormBody = requestFormBody.join("&");
		this.callAPI(
			VERIFY_OTP_ACTION,
			API_BASE_URL + API_URL.v1 +API_URL.VERIFY_OTP,
			HttpMethod.POST,
			requestFormBody,
			(apiResponse) => {
				if (apiResponse.status === OperationStatus.SUCCESS) {
					store.dispatch({
						type: VERIFY_OTP_ACTION,
						response: apiResponse.data.data,
					});
				}
				callback(apiResponse);
			}
		);
	}
}
